import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('Start intercept');

    // Define domains where Authorization header should NOT be added
    const skipAuthForDomains = ['https://api.cloudinary.com'];

    // Check if current request URL matches any of the skipped domains
    const shouldSkipAuth = skipAuthForDomains.some(domain =>
      request.url.startsWith(domain)
    );

    if (shouldSkipAuth) {
      console.log('Skipping JWT for whitelisted domain:', request.url);
      return next.handle(request);
    }

    if (this.authenticationService != null) {
      console.log('In jwt interceptor - about to try and get current token');

      const token = this.authenticationService.currentUserValue?.token;

      console.log('In jwt interceptor - current token is:', token);

      if (token != null && token.length > 0) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      } else {
        if (!environment.production) console.log('No token found');
      }
    }

    return next.handle(request);
  }
}

// Export the interceptor provider
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
];